<template>
  <form class="form" @submit.prevent="submitData">
    <p>Please Note: Each photo or media pass is only good for one attendee.</p>
    <p class="has-text-danger"><strong>INDIVIDUALS REQUESTING TO COVER THE FESTIVAL MUST FILL OUT THEIR OWN APPLICATION.</strong></p>

    <fieldset class="box">
      <legend>Personal Details</legend>
      <div class="field">
        <label class="label">Media Outlet Name* </label>
        <div class="control">
          <input
            class="input"
            type="text"
            name="outletName"
            v-model.trim="form.outletName"
            :class="{ 'is-danger': $v.form.outletName.$error }"
            @blur="$v.form.outletName.$touch()"
            required>
        </div>
        <p class="help is-danger" v-show="$v.$anyDirty" v-if="!$v.form.outletName.required">You must fill out this field.</p>
        <p
          class="help is-danger"
          v-if="!$v.form.outletName.maxLength">Media Outlet name cannot be longer than {{ $v.form.outletName.$params.maxLength.max }} characters.</p>
        <div class="field">
          <label class="label">Outlet Type* </label>
          <div class="control">
            <div class="select">
              <select
                name="outletType"
                v-model="form.outletType">
                <option value="College">College</option>
                <option value="Blog">Online/Blog</option>
                <option value="Print" selected>Print</option>
                <option value="Radio">Radio</option>
                <option value="TV">TV</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">Coverage* </label>
          <div class="control">
            <div class="select">
              <select
                name="coverage"
                v-model="form.coverage">
                <option value="International">International</option>
                <option value="National" selected>National</option>
                <option value="Regional">Regional</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">First Name* </label>
          <div class="control">
            <input
              class="input"
              type="text"
              name="firstname"
              v-model="form.firstName"
              :class="{ 'is-danger': $v.form.firstName.$error }"
              @blur="$v.form.firstName.$touch()"
              required>
          </div>
          <p
            class="help is-danger"
            v-if="!$v.form.firstName.required"
            v-show="$v.$anyDirty">Please enter your first name.</p>
          <p
            class="help is-danger"
            v-if="!$v.form.firstName.maxLength">Your first name cannot be longer than {{ $v.form.firstName.$params.maxLength.max }} characters.</p>
        </div>
        <div class="field">
          <label class="label">Last Name* </label>
          <div class="control">
            <input
              class="input"
              type="text"
              name="lastname"
              v-model="form.lastName"
              :class="{ 'is-danger': $v.form.lastName.$error }"
              @blur="$v.form.lastName.$touch()"
              required>
          </div>
          <p
            class="help is-danger"
            v-if="!$v.form.lastName.required"
            v-show="$v.$anyDirty">Please enter your last name.</p>
          <p
            class="help is-danger"
            v-if="!$v.form.lastName.maxLength">Your last name cannot be longer than {{ $v.form.lastName.$params.maxLength.max }} characters.</p>
        </div>
        <div class="field">
          <label class="label">Mobile Number </label>
          <div class="control">
            <input
              class="input"
              type="text"
              name="mobile"
              v-model="form.mobile">
          </div>
        </div>
        <div class="field">
          <label class="label">Email Address* </label>
          <div class="control">
            <input
              class="input"
              type="email"
              name="email"
              v-model="form.email"
              :class="{ 'is-danger': $v.form.email.$error }"
              @blur="$v.form.email.$touch()"
              required>
          </div>
          <p
            class="help"
            :class="{ 'has-text-grey': !$v.$dirty, 'has-text-danger': !$v.form.email.email }">Please Note: <strong>A valid email address MUST be submitted with your application</strong>. If we can not reach you via email, your application will not be considered.</p>
        </div>
    </div></fieldset>

    <fieldset class="box">
      <legend>Press Coverage</legend>
      <div class="field">
        <label class="label">Publication Website* </label>
        <div class="control">
          <input
            class="input"
            type="url"
            name="publication-url"
            v-model="form.publicationURL"
            placeholder="https://yourpublication.com"
            :class="{ 'is-danger': $v.form.publicationURL.$error }"
            @blur="$v.form.publicationURL.$touch()"
            required>
        </div>
        <p
          class="help is-danger"
          v-if="!$v.form.publicationURL.required"
          v-show="$v.$anyDirty">Please enter your publication's web address/URL.</p>
        <p
          class="help is-danger"
          v-if="!$v.form.publicationURL.maxLength">Your website URL cannot be longer than {{ $v.form.publicationURL.$params.maxLength.max }} characters.</p>
        <p
          class="help is-danger"
          v-if="!$v.form.publicationURL.url">Please enter a valid web address/URL.</p>
      </div>
      <div class="field">
        <label class="label">Doing Advanced Coverage?</label>
        <div class="control">
          <label class="radio">
            <input
              type="radio"
              name="advanced-coverage"
              value="Yes"
              v-model="form.advancedCoverage">
            Yes
          </label>
          <label class="radio">
            <input
              type="radio"
              name="advanced-coverage"
              value="No"
              v-model="form.advancedCoverage"
              checked>
            No
          </label>
        </div>
      </div>
      <div class="field">
        <label class="label">Doing Post-Event Coverage?</label>
        <div class="control">
          <label class="radio">
            <input
              type="radio"
              value="Yes"
              name="post-event-coverage"
              v-model="form.postEventCoverage">
            Yes
          </label>
          <label class="radio">
            <input
              type="radio"
              name="post-event-coverage"
              value="No"
              v-model="form.postEventCoverage"
              checked>
            No
          </label>
        </div>
      </div>
      <div class="field">
        <label class="label">Assignment Details</label>
        <div class="control">
          <textarea
            class="textarea"
            type="text"
            rows="6"
            name="assignment-details"
            :class="{ 'is-danger': $v.form.assignmentDetails.$error }"
            v-model="form.assignmentDetails" />
        </div>
        <p
          class="help is-danger"
          v-if="!$v.form.assignmentDetails.maxLength">Your Assignment Details cannot be longer than {{ $v.form.assignmentDetails.$params.maxLength.max }} characters.</p>
      </div>
      <div class="field">
        <label class="label">Editor/Producer Full Name* </label>
        <div class="control">
          <input
            class="input"
            type="text"
            name="editor-name"
            v-model="form.editorName"
            :class="{ 'is-danger': $v.form.editorName.$error }"
            @blur="$v.form.editorName.$touch()"
            required>
        </div>
        <p
          class="help is-danger"
          v-if="!$v.form.editorName.required"
          v-show="$v.$anyDirty">Please enter your Editor/Producer's full name.</p>
        <p
          class="help is-danger"
          v-if="!$v.form.editorName.maxLength">Your website URL cannot be longer than {{ $v.form.editorName.$params.maxLength.max }} characters.</p>
      </div>
      <div class="field">
        <label class="label">Editor/Producer Email* </label>
        <div class="control">
          <input
            class="input"
            type="email"
            name="editor-email"
            v-model="form.editorEmail"
            :class="{ 'is-danger': $v.form.editorEmail.$error }"
            @blur="$v.form.editorEmail.$touch()"
            required>
        </div>
        <p
          class="help is-danger"
          v-if="!$v.form.editorEmail.email"
          v-show="$v.$anyDirty">Please enter a valid email address.</p>
        <p
          class="help is-danger"
          v-if="!$v.form.editorEmail.required"
          v-show="$v.$anyDirty">Please enter a valid email address.</p>
      </div>
      <div class="field">
        <label class="label">Editor/Producer Phone* </label>
        <div class="control">
          <input
            class="input"
            type="tel"
            name="editor-phone"
            v-model="form.editorMobile"
            :class="{ 'is-danger': $v.form.editorMobile.$error }"
            @blur="$v.form.editorMobile.$touch()"
            required>
        </div>
        <p
          class="help is-danger"
          v-if="!$v.form.editorMobile.required"
          v-show="$v.$anyDirty">Please enter your Editor/Producer's contact number.</p>
        <p
          class="help is-danger"
          v-if="!$v.form.editorMobile.maxLength">The contact number cannot be longer than {{ $v.form.editorMobile.$params.maxLength.max }} characters.</p>
      </div>
      <div class="field">
        <label class="label">Previous Press Coverage</label>
        <div class="control">
          <textarea
            class="textarea"
            type="text"
            rows="10"
            name="previous-coverage"
            :class="{ 'is-danger': $v.form.previousCoverage.$error }"
            @blur="$v.form.previousCoverage.$touch()"
            v-model="form.previousCoverage"/>
        </div>
        <p class="help">Please include links showing examples of coverage of similar events. Highly recommended for consideration.</p>
        <p
          class="help is-danger"
          v-if="!$v.form.previousCoverage.maxLength">The information you entered cannot be longer than {{ $v.form.previousCoverage.$params.maxLength.max }} characters.</p>
      </div>
      <div class="field">
        <label class="label">Pass Type</label>
        <div class="control">
          <div class="select">
            <select
              name="pass-type"
              v-model="form.passType">
              <option value="Media" selected>Media</option>
              <option value="Photo">Photo</option>
              <option value="Video">Video</option>
            </select>
          </div>
        </div>
      </div>
    </fieldset>
    <notifications group="standard" position="top center" width="50%"></notifications>
    <div class="field">
      <div class="control">
        <button
          type="submit"
          class="button is-large is-fullwidth is-success">SUBMIT APPLICATION</button>
      </div>
    </div>
  </form>
</template>

<script>
import formMixin from '@/mixins/form'
import { email, minLength, maxLength, required, url } from 'vuelidate/lib/validators'
import db from './firebaseInit'
import moment from 'moment'

export default {
  name: 'DinahMediaForm',
  props: {
    ip: {
      type: String,
      required: true
    }
  },
  mixins: [formMixin],
  data () {
    return {
      processing: false,
      form: {
        outletName: '',
        outletType: 'Print',
        coverage: 'National',
        firstName: '',
        lastName: '',
        mobile: '',
        email: '',
        publicationURL: '',
        advancedCoverage: 'No',
        postEventCoverage: 'No',
        assignmentDetails: '',
        editorName: '',
        editorEmail: '',
        editorMobile: '',
        previousCoverage: '',
        passType: 'Media'
      }
    }
  },
  validations: {
    form: {
      outletName: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(50)
      },
      outletType: { required },
      coverage: { required },
      firstName: {
        required,
        maxLength: maxLength(50)
      },
      lastName: {
        required,
        maxLength: maxLength(50)
      },
      mobile: { maxLength: maxLength(25) },
      email: { required, email },
      publicationURL: {
        required,
        url,
        maxLength: maxLength(75)
      },
      assignmentDetails: {
        maxLength: maxLength(255)
      },
      editorName: {
        required,
        maxLength: maxLength(50)
      },
      editorEmail: {
        required,
        email
      },
      editorMobile: {
        required,
        maxLength: maxLength(50)
      },
      previousCoverage: { maxLength: maxLength(255) },
      passType: { required }
    }
  },
  methods: {
    submitData () {
      this.processing = true
      this.$v.form.$touch()
      if (this.$v.form.$anyError) throw new Error('There are errors on the form. Please review your answers.')

      db.collection('pressCredentials').add({
        outletName: this.form.outletName,
        outletType: this.form.outletType,
        coverage: this.form.coverage,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        mobile: this.form.mobile,
        email: this.form.email,
        publicationURL: this.form.publicationURL,
        advancedCoverage: this.form.advancedCoverage,
        postEventCoverage: this.form.postEventCoverage,
        assignmentDetails: this.form.assignmentDetails,
        editorName: this.form.editorName,
        editorEmail: this.form.editorEmail,
        editorMobile: this.form.editorMobile,
        previousCoverage: this.form.previousCoverage,
        passType: this.form.passType,
        IP: this.ip,
        dateSubmitted: moment().utcOffset(-420).format('LLL')
      })
      .then((docRef) => {
        this.$notify({
          group: 'standard',
          title: 'Success!',
          text: 'Your application has been submitted!',
          classes: 'is-success'
        })
      })
      .catch((error) => {
        throw new Error(error)
      })
    },
    confirmSaved(response) {
      this.$notify({
        group: 'standard',
        title: 'Success',
        text: response
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .form {
    margin: 2em 0;

    fieldset {
      margin: 1em 0;

      p.help {
        margin-bottom: 1.5em;
      }
    }
  }
</style>
